/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check-arrow': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<defs><path pid="0" d="M16.605 8.304l.093.093a1.046 1.046 0 010 1.47l-5.755 5.828a1.02 1.02 0 01-1.454 0l-3.187-3.221a1.046 1.046 0 010-1.47l.093-.094a1.02 1.02 0 011.454 0l2.372 2.398 4.93-4.994a1.01 1.01 0 011.454-.01z" id="svgicon_check-arrow_a"/></defs><use _fill="#FFF" xlink:href="#svgicon_check-arrow_a" transform="translate(-6 -8)" fill-rule="evenodd"/>'
  }
})
